import PropTypes from "prop-types";
import Dropdown from "@shared/v2/Dropdown/Dropdown";

const REASON_OPTIONS = [
  { label: "Vacant Land", value: "Vacant Land" },
  { label: "Investment Property", value: "Investment Property" },
  { label: "Renovation/Tear Down", value: "Renovation/Tear Down" },
  { label: "Buyer/Tenant Already Lives Here", value: "Buyer/Tenant Already Lives Here" },
  { label: "Other", value: "Other" },
];

const DisableConnectServiceDropdown = ({ value, onChange, error, label, placeholder }) => (
  <Dropdown
    label={label}
    placeholder={placeholder}
    options={REASON_OPTIONS}
    value={value}
    onChange={onChange}
    error={error}
    isRequired
    menuShouldComeToFront
  />
);

DisableConnectServiceDropdown.propTypes = {
  value: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

DisableConnectServiceDropdown.defaultProps = {
  value: null,
  error: null,
  label: "Reason to Disable",
  placeholder: "Select",
};

export default DisableConnectServiceDropdown;
